import React, { useState } from "react";
import {
  Modal,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from "react-bootstrap";
import { saveNewCategory } from "../../../api/clinicalTrial";
import { useTranslation } from "react-i18next";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const ModalCreateCategory = ({
  show,
  onClose,
  onCreated,
  defaultEntityTypeId = "0",
  currentPath = "",
}) => {
  const { t } = useTranslation();
  const [categoryName, setCategoryName] = useState("");
  const [entityType, setEntityType] = useState(defaultEntityTypeId);
  const [multipleFiles, setMultipleFiles] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!categoryName.trim() || !entityType) return;
    setSaving(true);
    try {
      const payload = {
        fileName: categoryName,
        entityType: Number(entityType),
        multipleFiles: multipleFiles,
        currentPath: Array.isArray(currentPath)
          ? currentPath.join("/")
          : currentPath,
      };

      const response = await saveNewCategory(payload);
      const created = response?.data ?? response;
      onCreated && onCreated(created, payload.currentPath);

      setCategoryName("");
      setEntityType("0");
      setMultipleFiles(false);
      onClose();
    } catch (err) {
      HandleApiError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="rounded-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t("clinicalTrials.isfFiles.createCategoryModal.modalTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup controlId="formCategoryName">
          <ControlLabel>
            {t("clinicalTrials.isfFiles.createCategoryModal.nameLabel")}{" "}
            <span className="text-danger">*</span>
          </ControlLabel>
          <FormControl
            type="text"
            placeholder={t(
              "clinicalTrials.isfFiles.createCategoryModal.namePlaceholder"
            )}
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          />
        </FormGroup>

        <FormGroup controlId="formEntityType">
          <ControlLabel>
            {t("clinicalTrials.isfFiles.createCategoryModal.fileTypeLabel")}{" "}
            <span className="text-danger">*</span>
          </ControlLabel>
          <FormControl
            componentClass="select"
            value={entityType}
            onChange={(e) => setEntityType(e.target.value)}
            disabled={defaultEntityTypeId && defaultEntityTypeId !== "0"}
          >
            {[0, 1, 2, 3].map((x) => (
              <option value={x}>
                {t(
                  `clinicalTrials.isfFiles.createCategoryModal.attachmentEntityTypes.${x}`
                )}
              </option>
            ))}
          </FormControl>
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose} disabled={saving}>
          {t(`clinicalTrials.isfFiles.createCategoryModal.cancelButtonLabel`)}
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={saving || !entityType || !categoryName}
        >
          {t(`clinicalTrials.isfFiles.createCategoryModal.saveButtonLabel`)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
